import * as types from "../../ActionType";

const initState = {
    statements: [],
    loadingStatements: true,
    one_statement: {},
    loadingOneStatement: true,
    page_list_statement: {},
    loadingPageListStatement: true
}

const StatementsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.PAGE_LIST_STATEMENT:
            return { ...state, page_list_statement: action.payload, loadingPageListStatement: false }
        case types.ADD_STATEMENT:
            return { ...state, loadingStatements: true }
        case types.GET_STATEMENTS:
            return { ...state, statements: action.payload, loadingStatements: false }
        
        case types.GET_ONE_STATEMENT:
            return { ...state, one_statement: action.payload, loadingOneStatement: false }
        case types.EMPTY_ONE_STATEMENT:
            return { ...state, one_statement: action.payload, loadingOneStatement: true }
        default:
            return state;
    }
};

export default StatementsReducer;

